var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcReview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "3lgcpv8hta"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#3lgcpv8hta)",
    transform: "translate(-138.000000, -328.000000) translate(16.000000, 315.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#343A40",
    fillRule: "nonzero",
    d: "M19.005 4.14l.617-.654c.156-.155.235-.332.238-.532.003-.2-.073-.378-.229-.533l-.206-.215c-.137-.137-.304-.198-.5-.183-.198.015-.37.097-.52.246l-.636.627 1.236 1.244zM8.898 13.253l1.701-.725 7.78-7.77-1.236-1.227-7.78 7.78-.76 1.638c-.042.083-.024.165.053.246.078.08.159.1.242.058zm6.75 5.595c.788 0 1.4-.227 1.84-.68.438-.454.657-1.126.657-2.015V7.157l-1.54 1.53v7.34c0 .43-.1.751-.3.963-.2.212-.442.318-.729.318H5.81c-.406 0-.716-.106-.931-.318-.215-.212-.323-.532-.323-.962V6.539c0-.424.108-.743.323-.958.215-.215.525-.322.93-.322h7.44l1.53-1.53H5.747c-.901 0-1.581.224-2.04.675-.46.45-.69 1.123-.69 2.019v9.73c0 .89.23 1.56.69 2.014.459.454 1.139.68 2.04.68h9.9z",
    transform: "translate(122.000000, 13.000000)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcReview);
export default __webpack_public_path__ + "static/media/ic_review.d1a8139c6176ee2a4d32cacad761ec64.svg";
export { ForwardRef as ReactComponent };